<div class="bg-primary-50 h-72 flex items-center justify-center">
    <div class="items-center text-center flex flex-col space-y-5">
        <div class="text-base text-tertiary-900 font-medium">
            Please wait while we verify your authentication status...
        </div>
        <app-loading-dots></app-loading-dots>
    </div>
</div>
